import { render, staticRenderFns } from "./facescan.vue?vue&type=template&id=3a2b3a98&scoped=true&"
import script from "./facescan.vue?vue&type=script&lang=js&"
export * from "./facescan.vue?vue&type=script&lang=js&"
import style0 from "./facescan.vue?vue&type=style&index=0&id=3a2b3a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b3a98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jasonliuhan/Documents/project/jcfy-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a2b3a98')) {
      api.createRecord('3a2b3a98', component.options)
    } else {
      api.reload('3a2b3a98', component.options)
    }
    module.hot.accept("./facescan.vue?vue&type=template&id=3a2b3a98&scoped=true&", function () {
      api.rerender('3a2b3a98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/container/facescan/facescan.vue"
export default component.exports